module.exports = __webpack_public_path__ + "static/media/arrow-down-white.aa69c4fc.svg";